import { render, staticRenderFns } from "./ChangeDept.vue?vue&type=template&id=4b0d4714&scoped=true&"
import script from "./ChangeDept.vue?vue&type=script&lang=js&"
export * from "./ChangeDept.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDept.vue?vue&type=style&index=0&id=4b0d4714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d4714",
  null
  
)

export default component.exports